module.exports = __webpack_public_path__ + "img/life@Q_qcares.e8019f49.jpg";